'use client'

const RATE_LIMIT_NOTICE_KEY = 'portal.rateLimitNotice'

export type RateLimitNotice = {
  until: number
  message?: string
}

export const setRateLimitNotice = (notice: RateLimitNotice): void => {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(RATE_LIMIT_NOTICE_KEY, JSON.stringify(notice))
  } catch {
    // ignore storage failures
  }
}

export const consumeRateLimitNotice = (): RateLimitNotice | null => {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.sessionStorage.getItem(RATE_LIMIT_NOTICE_KEY)
    if (!raw) return null
    window.sessionStorage.removeItem(RATE_LIMIT_NOTICE_KEY)
    const parsed = JSON.parse(raw) as Partial<RateLimitNotice>
    if (typeof parsed.until === 'number' && Number.isFinite(parsed.until)) {
      return { until: parsed.until, message: parsed.message }
    }
  } catch {
    return null
  }
  return null
}
